<template lang="pug" src="./app.pug"></template>
<style lang="scss" src="./app.scss"></style>

<script>
import {mapGetters, mapState} from 'vuex';
import navigation from '@/components/navigation';
import {resetState} from '@/store/index';
import {VMain} from "vuetify/lib/components";
import request from "@/utils/request";

export default {
  components: {
    'v-navigation': navigation,
    'v-main': VMain
  },
  data: () => ({
    popover: false,
    loginCheckInterval: 0,
    requestProcessing: false,
    links: ['/history', '/users/drivers',
      '/users/operators', '/finances/tariffs',
      '/finances/commissions', '/reports',
      '/bonuses/driver', '/bonuses/client',
      '/resales/list', '/form-answers',
      '/technical-support', '/resales/list',
      '/establishments', '/products'
    ],
    lastKey: true
  }),
  computed: {
    ...mapGetters(['loggedIn', 'roleName', 'user']),
    ...mapState({
      drawer: (state) => state.data.drawer
    }),
    routeName() {
      const {meta} = this.$route;

      if (!meta) {
        return;
      }

      return meta.useTitle ? `${meta.name}.title` : `${meta.name}`;
    },
    notUseContainer() {
      return this.$route && this.$route.meta && this.$route.meta.notUseContainer || false;
    },
    isFullWidth() {
      return this.links.includes(this.$route.path);
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (!!to.params.id && !!from.params.id) {
      this.lastKey = !this.lastKey;
    }

    next();
  },
  mounted() {
    this.loginCheckInterval = setInterval(() => {
      request({ method: 'get', url: '/account' })
          .catch((e) => {
            if (e.message.includes(401)) {
              this.logout();
            }
          });
    }, 600000);
  },
  beforeDestroy() {
    clearInterval(this.loginCheckInterval);
  },
  methods: {
    logout() {
      if (this.requestProcessing) return;

      this.requestProcessing = true;

      this.$store.dispatch('auth/logout').then(() => {
        this.$nextTick(() => this.requestProcessing = false);
      });

      resetState();
    },
    toggleDrawer() {
      this.$store.commit('data/SET_DRAWER', !this.drawer);
    }
  }
};
</script>
